import { render, staticRenderFns } from "./detailHandle.vue?vue&type=template&id=069b0fca&scoped=true&"
import script from "./detailHandle.vue?vue&type=script&lang=js&"
export * from "./detailHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b0fca",
  null
  
)

export default component.exports